const useRemote = process.env.REACT_APP_USE_REMOTE === 'true';
const remote_url = process.env.REACT_APP_API_URL;
const local_url = process.env.REACT_APP_LOCAL_API_URL;
const base_url = useRemote ? remote_url : local_url;
export { base_url }
